export default __webpack_public_path__ + "ZurichMedicalProvidersUae.pdf";